module.exports = __webpack_public_path__ + "static/media/error.256cd66d.gif";